import React from 'react';
import { FaUser, FaPercentage, FaMoneyBillWave, FaChartLine } from 'react-icons/fa';

const SidePanel = ({ isOpen, onClose, analyticsData, salesAgents }) => {
  if (!analyticsData) return null;

  return (
    <>
      <div className={`side-panel-overlay ${isOpen ? 'open' : ''}`} onClick={onClose} />
      <div className={`side-panel ${isOpen ? 'open' : ''}`}>
        <div className="side-panel-header">
          <h2>Analytics Summary</h2>
          <button className="side-panel-close" onClick={onClose}>×</button>
        </div>
        <div className="side-panel-content">
          <div className="side-panel-cards">
            <div className="side-panel-card">
              <div className="card-icon">
                <FaUser />
              </div>
              <div className="card-content">
                <h3>Total Agents</h3>
                <p>{salesAgents?.length || 0}</p>
              </div>
            </div>

            <div className="side-panel-card">
              <div className="card-icon">
                <FaPercentage />
              </div>
              <div className="card-content">
                <h3>Overall Closing Rate</h3>
                <p>{analyticsData.overallClosingPercentage.toFixed(2)}%</p>
              </div>
            </div>

            <div className="side-panel-card">
              <div className="card-icon">
                <FaPercentage />
              </div>
              <div className="card-content">
                <h3>Opportunity Closed Rate</h3>
                <p>{analyticsData.overallOpportunityClosedPercentage.toFixed(2)}%</p>
              </div>
            </div>

            <div className="side-panel-card">
              <div className="card-icon">
                <FaMoneyBillWave />
              </div>
              <div className="card-content">
                <h3>Avg. Cost/User</h3>
                <p>${analyticsData.averageCostPerUser.toFixed(2)}</p>
              </div>
            </div>

            <div className="side-panel-card">
              <div className="card-icon">
                <FaChartLine />
              </div>
              <div className="card-content">
                <h3>Booked Ratio</h3>
                <p>{analyticsData.totalBooked} / {analyticsData.totalContacted}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SidePanel; 